import * as React from "react";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Container,
  Card,
  Box,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";

export const InfoCard = ({ title, value, units }) => {
  const internalCard = {
    color: "#00319d",
    fontSize: "1rem",
    marginBottom: "0.3rem",
    fontFamily: "DM Sans, sans-serif",
  };

  const cardstyles = {
    boxShadow: "none",
    borderRadius: "18px",
    minWidth: 300,
    maxWidth: 500,
    display: "flex",
    alignItems: "center",
    p: 2,
    margin: "5px",
  };

  const TypographyStyle = {
    marginLeft: "0.8rem",
    marginTop: "0.3rem",
    display: "flex",
    flexDirection: "column",
  };

  const fonstStyle = {
    fontWeight: "bold",
    fontFamily: "DM Sans, sans-serif",
    fontSize: "1rem",
  };

  return (
    <>
      <Grid item>
        <Card sx={cardstyles}>
          <Box sx={TypographyStyle}>
            <Typography sx={internalCard}>{title}</Typography>

            <Typography sx={fonstStyle}>
              {value}{" "}
              {value != "N/A" && (
                <span
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "500",
                    color: "#5b6775",
                  }}
                >
                  {units}
                </span>
              )}
            </Typography>
          </Box>
        </Card>
      </Grid>
    </>
  );
};
